import { render } from "./BlogWhiteSmileSecrets.vue?vue&type=template&id=39368de2"
import script from "./BlogWhiteSmileSecrets.vue?vue&type=script&lang=js"
export * from "./BlogWhiteSmileSecrets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__